import React, { useState, useRef, useEffect } from "react";
import { TextBox, Button } from "devextreme-react";
import {
  SelectBox,
  Button as SelectBoxButton,
} from "devextreme-react/select-box";
import ScrollView from "devextreme-react/scroll-view";
import { RequiredRule, Validator } from "devextreme-react/validator";
import ValidationGroup from "devextreme-react/validation-group";
import { useAuth } from "../../contexts/auth";
import notify from "devextreme/ui/notify";
import Server from "../../api/Server";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/mode-javascript";
import { compareAndMergeApplications } from "../../utils";
import NewAppNameModal from "./NewAppNameModal";
import { alert } from "devextreme/ui/dialog";

const allLevels = [
  { id: 1, value: "Company" },
  { id: 2, value: "Warehouse" },
  { id: 3, value: "Pos" },
  { id: 4, value: "User" },
];

const valueTypes = [
  { id: 1, value: "JSON" },
  // { id: 2, value: "JSON array" },
  { id: 3, value: "string" },
];

const initialState = {
  level: "",
  level_id: "",
  type: "",
  name: "",
  value: "",
  valueType: "",
  application: "",
};

export default ({
  setIsAdd,
  application,
  fetchConfig,
  isNewApp,
  setIsNewApp,
}) => {
  const [newConfigData, setData] = useState(initialState);
  const [newGroup, setNewGroup] = useState(false);
  const [allApplications, setApplications] = useState([]);

  const [src, setSrc] = useState({});

  const selectRef = useRef(null);

  const { user, wareHouses, allUsers, registers, accounts, getAccounts } =
    useAuth();

  const { level, level_id, value, name, type, valueType } = newConfigData;

  useEffect(() => {
    setApplications(compareAndMergeApplications(accounts));
  }, [accounts]);

  const onValueChange = (e, name) => {
    const { value } = e;

    setData({ ...newConfigData, [name]: value });
  };

  const renderLevelID = () => {
    switch (level) {
      case "Warehouse":
        return (
          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Level ID</span>
            <SelectBox
              dataSource={wareHouses}
              displayExpr='name'
              valueExpr='warehouseID'
              value={level_id}
              onValueChanged={(e) => onValueChange(e, "level_id")}
              valueChangeEvent='keyup'
              searchEnabled={true}
            />
          </div>
        );

      case "Pos":
        return (
          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Level ID</span>
            <SelectBox
              dataSource={registers}
              displayExpr='name'
              valueExpr='pointOfSaleId'
              value={level_id}
              onValueChanged={(e) => onValueChange(e, "level_id")}
              valueChangeEvent='keyup'
              searchEnabled={true}
            />
          </div>
        );

      case "User":
        return (
          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Level ID</span>
            <SelectBox
              dataSource={allUsers}
              displayExpr='userName'
              valueExpr='userID'
              value={level_id}
              onValueChanged={(e) => onValueChange(e, "level_id")}
              valueChangeEvent='keyup'
              searchEnabled={true}
            />
          </div>
        );

      default:
        return (
          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Level ID</span>
            <TextBox
              placeholder='Level ID'
              value={level_id}
              showClearButton={true}
              onValueChanged={(e) => onValueChange(e, "level_id")}
              valueChangeEvent='keyup'
              searchEnabled={true}
            />
          </div>
        );
    }
  };

  const handleSave = async (args) => {
    // const validationResult = selectRef.current.instance.validate();

    // if (validationResult && !validationResult.isValid) {
    //   return;
    // }

    if (!args.validationGroup.validate().isValid) {
      return;
    }

    if (!newConfigData.value) {
      alert("Please add a value to configuration", "Notification");
      return;
    }

    const values = {
      application: isNewApp ? newConfigData.application : application,
      level: newConfigData.level,
      level_id: newConfigData.level_id.toString(),
      name: newConfigData.name,
      type: newConfigData.type,
      value: newConfigData.value,
    };

    try {
      const { data } = await Server.saveAccountConfig(values, user.baseUrl, {
        clientCode: user.clientCode,
        sessionKey: user.sessionKey,
      });

      if (!isNewApp) {
        const params = {
          application,
        };

        fetchConfig(
          params,
          user.baseUrl,
          {
            clientCode: user.clientCode,
            sessionKey: user.sessionKey,
          },
          true
        );
        notify(`${data.message}`, "success", 3000);
      } else {
        getAccounts(user.baseUrl, {
          clientCode: user.clientCode,
          sessionKey: user.sessionKey,
        });

        notify(
          "Configuration saved. Select the application to view saved configuration",
          "success",
          3000
        );
      }

      setData(initialState);
      if (isNewApp && setIsNewApp) {
        setIsNewApp();
      }
      args.validationGroup.reset();
    } catch (error) {
      const {
        response: { data },
      } = error;

      if (data) {
        notify(`${data.message}`, "error", 3000);
      } else {
        notify(`Error performing operation`, "error", 3000);
      }
    }
  };

  const selectButton = {
    // icon: "plus",
    type: "default",
    text: "Add new",
    onClick: () => {
      setNewGroup(true);
      selectRef.current.instance.close();
    },
  };

  const closeNewGroup = () => {
    setNewGroup(false);
  };

  const addNewAppName = (name) => {
    const apps = [...allApplications];

    if (!name.trim()) {
      alert("Please add application name", "Notification");
      return;
    }

    const isAdded = apps.find((app) => app.value.trim() === name.trim());

    if (isAdded) {
      notify(`Application with name: '${name}' already exists `, "error", 3000);
      return;
    }

    setApplications([...allApplications, { value: name, id: name }]);
    closeNewGroup();
  };

  return (
    <React.Fragment>
      {isNewApp ? (
        <ValidationGroup className='responsive-paddings'>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <Button type='default' stylingMode='contained' onClick={handleSave}>
              Save configuration
            </Button>
          </div>
          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Application</span>
            <SelectBox
              placeholder='Select application or add new application'
              dataSource={allApplications}
              displayExpr='value'
              valueExpr='value'
              value={newConfigData.application}
              showClearButton={true}
              searchEnabled={true}
              onValueChanged={(e) => onValueChange(e, "application")}
              valueChangeEvent='keyup'
              ref={selectRef}
            >
              <Validator>
                <RequiredRule message='Application is required' />
              </Validator>
              <SelectBoxButton
                name='productGroup'
                location='before'
                options={selectButton}
              />
              <SelectBoxButton name='clear' />
              <SelectBoxButton name='dropDown' />
            </SelectBox>
          </div>
          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Level</span>
            <SelectBox
              placeholder='Select level'
              dataSource={allLevels}
              displayExpr='value'
              valueExpr='value'
              value={level}
              showClearButton={true}
              searchEnabled={true}
              onValueChanged={(e) => onValueChange(e, "level")}
              valueChangeEvent='keyup'
            >
              <Validator>
                <RequiredRule message='Level is required' />
              </Validator>
            </SelectBox>
          </div>
          {renderLevelID()}

          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Type</span>
            <TextBox
              placeholder='Type'
              value={type}
              showClearButton={true}
              onValueChanged={(e) => onValueChange(e, "type")}
              valueChangeEvent='keyup'
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Name</span>
            <TextBox
              placeholder='Name'
              value={name}
              showClearButton={true}
              onValueChanged={(e) => onValueChange(e, "name")}
              valueChangeEvent='keyup'
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <span className='sub-title'>Value Type</span>
            <SelectBox
              placeholder='Select value type'
              dataSource={valueTypes}
              displayExpr='value'
              valueExpr='value'
              value={valueType}
              showClearButton={true}
              searchEnabled={true}
              onValueChanged={(e) => onValueChange(e, "valueType")}
              valueChangeEvent='keyup'
            />
          </div>
          {valueType ? (
            <React.Fragment>
              {valueType !== "string" ? (
                <div style={{ marginBottom: "15px" }}>
                  <span className='sub-title'>Value</span>

                  <AceEditor
                    placeholder='Enter configuration here'
                    mode={
                      // newConfigData.valueType === "JSON" ? "json" : "javascript"
                      "json"
                    }
                    theme='monokai'
                    name='blah2'
                    onChange={(value, _) => {
                      setData({ ...newConfigData, value });
                    }}
                    fontSize={14}
                    width={"100%"}
                    showPrintMargin={false}
                    showGutter={true}
                    highlightActiveLine={true}
                    editorProps={{ $blockScrolling: true }}
                    value={newConfigData.value}
                    setOptions={{
                      enableBasicAutocompletion: true,
                      enableLiveAutocompletion: true,
                      enableSnippets: true,
                      showLineNumbers: true,
                      tabSize: 2,
                    }}
                  />
                </div>
              ) : (
                <div style={{ marginBottom: "15px" }}>
                  <span className='sub-title'>Value</span>
                  <TextBox
                    placeholder='Value'
                    value={value}
                    showClearButton={true}
                    valueChangeEvent='keyup'
                    onValueChanged={(e) => onValueChange(e, "value")}
                  />
                </div>
              )}
            </React.Fragment>
          ) : null}
        </ValidationGroup>
      ) : (
        <ScrollView
          width='100%'
          height='100%'
          className='dx-card responsive-paddings'
        >
          <ValidationGroup>
            <h6
              style={{
                marginRight: "0",
                marginBottom: "5px",
                marginTop: "0",
                marginLeft: "0",
              }}
            >
              Add New Configuration
            </h6>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <Button
                type='back'
                stylingMode='contained'
                onClick={() => setIsAdd(false)}
              />
              <Button
                type='default'
                stylingMode='contained'
                onClick={handleSave}
              >
                Save configuration
              </Button>
            </div>
            <div style={{ marginBottom: "15px" }}>
              <span className='sub-title'>Level</span>
              <SelectBox
                placeholder='Select level'
                dataSource={allLevels}
                displayExpr='value'
                valueExpr='value'
                value={level}
                showClearButton={true}
                searchEnabled={true}
                onValueChanged={(e) => onValueChange(e, "level")}
                valueChangeEvent='keyup'
              >
                <Validator>
                  <RequiredRule message='Level is required' />
                </Validator>
              </SelectBox>
            </div>
            {renderLevelID()}

            <div style={{ marginBottom: "15px" }}>
              <span className='sub-title'>Type</span>
              <TextBox
                placeholder='Type'
                value={type}
                showClearButton={true}
                onValueChanged={(e) => onValueChange(e, "type")}
                valueChangeEvent='keyup'
              />
            </div>
            <div style={{ marginBottom: "15px" }}>
              <span className='sub-title'>Name</span>
              <TextBox
                placeholder='Name'
                value={name}
                showClearButton={true}
                onValueChanged={(e) => onValueChange(e, "name")}
                valueChangeEvent='keyup'
              />
            </div>
            <div style={{ marginBottom: "15px" }}>
              <span className='sub-title'>Value Type</span>
              <SelectBox
                placeholder='Select value type'
                dataSource={valueTypes}
                displayExpr='value'
                valueExpr='value'
                value={valueType}
                showClearButton={true}
                searchEnabled={true}
                onValueChanged={(e) => onValueChange(e, "valueType")}
                valueChangeEvent='keyup'
              />
            </div>
            {valueType ? (
              <React.Fragment>
                {valueType !== "string" ? (
                  <div style={{ marginBottom: "15px" }}>
                    <span className='sub-title'>Value</span>

                    <AceEditor
                      placeholder='Enter configuration here'
                      mode={
                        // newConfigData.valueType === "JSON" ? "json" : "javascript"
                        "json"
                      }
                      theme='monokai'
                      name='blah2'
                      onChange={(value, _) => {
                        setData({ ...newConfigData, value });
                      }}
                      fontSize={14}
                      width={"100%"}
                      showPrintMargin={false}
                      showGutter={true}
                      highlightActiveLine={true}
                      editorProps={{ $blockScrolling: true }}
                      value={newConfigData.value}
                      setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        enableSnippets: true,
                        showLineNumbers: true,
                        tabSize: 2,
                      }}
                    />
                  </div>
                ) : (
                  <div style={{ marginBottom: "15px" }}>
                    <span className='sub-title'>Value</span>
                    <TextBox
                      placeholder='Value'
                      value={value}
                      showClearButton={true}
                      valueChangeEvent='keyup'
                      onValueChanged={(e) => onValueChange(e, "value")}
                    />
                  </div>
                )}
              </React.Fragment>
            ) : null}
          </ValidationGroup>
        </ScrollView>
      )}

      <NewAppNameModal
        visible={newGroup}
        onHide={closeNewGroup}
        addNewAppName={addNewAppName}
      />
    </React.Fragment>
  );
};
